import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import type { IconButtonProps } from '@mui/material/IconButton';
import type { SvgIconProps } from '@mui/material/SvgIcon';

type ClearButtonProps = {
  onClick: () => void;
  visible?: boolean;
  buttonProps?: IconButtonProps;
  iconProps?: SvgIconProps;
};
export const InputClearButton: React.FC<ClearButtonProps> = (props) => {
  const { onClick, visible = false, buttonProps, iconProps } = props;

  return (
    <IconButton
      sx={{
        display: visible ? '' : 'none',
        padding: '4px',
        mr: 1.5,
      }}
      onClick={onClick}
      {...buttonProps}
    >
      <ClearIcon fontSize='small' {...iconProps} />
    </IconButton>
  );
};
